import React from "react";
import { FooterWrapper } from "./Styled";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Box, LazyImage, SpanStyled } from "../../styled/Elements";
import { WhiteLogo } from "../../styled/AllImages";
import { footerNavs, socialIcon } from "../../data/data";
import { Link } from "react-scroll";
import AppStoreDownloadBadges from "../../common/AppStoreDownloadBadges";
const Footer = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const date_year = new Date();
  return (
    <FooterWrapper id="home" className="container-fluid footerWrapper" lang={language}>
      <Box className="footerCrWrapper">
        <Container className="footerContain2">
          <Row className="footer-row">
            <Box className="logoNavsWrapper">
              <Box className="footerLogo mt-2">
                <LazyImage src={WhiteLogo} />
              </Box>
              <Box className="text-center copyright mt-2">
                <Box className="footerLink">
                  {footerNavs.map((item, key) => (
                    <Box key={key}>
                      <Link
                        style={{ color: "var(--white)" }}
                        to={item.to}
                        spy={true}
                        smooth={true}
                        offset={-60}
                        duration={500}
                        // activeClass="active"
                      >
                        {t(item.label)}
                      </Link>
                    </Box>
                  ))}
                </Box>
                <Box className="footerCopyright">
                  <SpanStyled
                    className="footer-op"
                    size="14px"
                    color="var(--white)"
                    transform="capitalize"
                  >
                    &copy; {date_year.getFullYear()}
                    <SpanStyled
                      className="footer-op footer-op-company"
                      size="14px"
                      color="var(--white)"
                    >
                      {" "}
                      {t("falhub")}.
                    </SpanStyled>
                  </SpanStyled>
                  <SpanStyled
                    className="footer-op footer-op-allRights"
                    size="14px"
                    color="var(--white)"
                    transform="capitalize"
                  >
                    {" "}
                    {t("AllRightReserved2")}.
                  </SpanStyled>
                </Box>
              </Box>
            </Box>
            <AppStoreDownloadBadges variant="footer" />
            <Row className="d-flex mt-2 gap-2">
              {socialIcon.map((list, key) => (
                <Col
                  className="contact-links"
                  key={key}
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                >
                  <a href={list.link} target="_blank" rel="noopener noreferrer">
                    <div className="social-icon d-flex justify-content-center align-items-center">
                      {list.img}
                    </div>
                  </a>
                </Col>
              ))}
            </Row>
          </Row>
        </Container>
      </Box>
    </FooterWrapper>
  );
};

export default Footer;
